import { API } from 'service/API'

import { ISignupDataJSON, ISignupStatus } from './SignupData'
import { IInvitedSignupDataJSON, IInviteeDataJSON } from './SignupInvited/InvitedSignupData'

interface ISignupServiceProps {
  API: API
}

export class SignupService {
  API: API

  constructor(props: ISignupServiceProps) {
    this.API = props.API
  }

  getStatus(): Promise<ISignupStatus> {
    return this.API.signup.getStatus()
  }

  proceedSignup(data: Partial<ISignupDataJSON>): Promise<Partial<ISignupDataJSON>> {
    return this.API.signup.proceed(data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  acceptInvitation(data: IInvitedSignupDataJSON): Promise<any> {
    return this.API.signup.acceptInvitation(data)
  }

  getInviteeData(data): Promise<IInviteeDataJSON> {
    return this.API.signup.getInviteeData(data)
  }
}
